import styled from "styled-components";

export const ReportWrapper = styled.div`
  .pro-sidebar,
  .footer-height,
  #header {
    display: none !important;
  }
`;
